import { login } from './login';

export default  {
  getCookie: function (name) {
    const strCookie = document.cookie;
    const arrCookie = strCookie.split('; ');
    for (let i = 0; i < arrCookie.length; i++) {
      const arr = arrCookie[i].split('=');
      if (name === arr[0]) {
        return arr[1];
      }
    }
    return null;
  },
  check: function (cb) {
    if (this.getCookie('login_type')) { // 检测登录
      cb();
    } else {
      login();
    }
  }
};

